<div nxModalContent>
  <div class="nx-margin-bottom-3m u-text-center">
    <h2 nxHeadline="subsection-large">{{ 'sports-list.headline' | translate }}</h2>
  </div>

  <ul nxList>
    <li *ngFor="let item of 'sports-list.leisure.list' | translate">{{ item }}</li>
  </ul>
</div>
<div nxModalActions class="modal-actions">
  <app-modal-close></app-modal-close>
</div>
